(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-category-browser"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-category-browser')) {
    customElements.define('collection-category-browser', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.buttons = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.tablist = this.querySelector('[role="tablist"]');
        this.mobile = window.matchMedia('(max-width: 989px)');
        const updateOrientation = () => this.tablist?.setAttribute('aria-orientation', this.mobile.matches ? 'horizontal' : 'vertical');
        updateOrientation();
        this.mobile.addEventListener('change', updateOrientation, { signal });

        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.activate(button, true), { signal });
          button.addEventListener('keydown', (event) => {
            let next;
            const previousKey = this.mobile.matches ? 'ArrowLeft' : 'ArrowUp';
            const nextKey = this.mobile.matches ? 'ArrowRight' : 'ArrowDown';
            if (event.key === previousKey) next = (index - 1 + this.buttons.length) % this.buttons.length;
            if (event.key === nextKey) next = (index + 1) % this.buttons.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.buttons.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.buttons[next].focus({ preventScroll: true });
            this.activate(this.buttons[next], true);
          }, { signal });
        });

        this.addEventListener('shopify:block:select', (event) => {
          const button = this.buttons.find((item) => item.closest('[data-block-id]')?.dataset.blockId === event.detail?.blockId);
          if (button) this.activate(button, true);
        }, { signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      activate(selectedButton, scroll) {
        this.buttons.forEach((button) => {
          const active = button === selectedButton;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          const active = panel.dataset.panel === selectedButton.dataset.target;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
        if (scroll && this.mobile.matches) {
          selectedButton.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
            inline: 'center',
            block: 'nearest'
          });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
